module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('brand.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.brand),
      expression: "filters.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand,
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('category.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.category),
      expression: "filters.category"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.fillProductTypes]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.name,
      domProps: {
        "value": category.name
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2)]), _vm._v(" "), (_vm.productTypes.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('productType.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.productType),
      expression: "filters.productType"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "productType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.productTypes), function(productType) {
    return _c('option', {
      key: productType.name,
      domProps: {
        "value": productType.id
      }
    }, [_vm._v(_vm._s(productType.name))])
  })], 2)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5808694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/exportProductCsv/filters/marketplace/Amazon.vue
// module id = 3493
// module chunks = 0